class WholesaleForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeForm();
    this.checkForSuccessMessage();
  }

  checkForSuccessMessage() {
    // Check if URL contains success parameters
    const urlParams = new URLSearchParams(window.location.search);
    const contactPosted = urlParams.get('contact_posted');
    
    if (contactPosted === 'true') {
      // Find the success message element
      const successElement = this.querySelector('#form-wholesale-success');
      
      if (successElement) {
        // Scroll to the success message with smooth animation
        setTimeout(() => {
          successElement.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'center' 
          });
        }, 100); // Small delay to ensure the element is rendered
      }
    }
  }

  initializeForm() {
    const countrySelect = this.querySelector('#WholesaleForm_AddressCountry');
    const provinceSelect = this.querySelector('#WholesaleForm_AddressProvince');
    const shippingCountrySelect = this.querySelector('#WholesaleForm_ShippingCountry');
    const shippingProvinceSelect = this.querySelector('#WholesaleForm_ShippingProvince');
    const sameAsBillingCheckbox = this.querySelector('#sameAsBilling');
    const shippingFields = this.querySelector('#shippingAddressFields');
    const taxIdInput = this.querySelector('#WholesaleForm_TaxID');

    // Initialize Tax ID formatting
    if (taxIdInput) {
      // taxIdInput.addEventListener('input', this.handleTaxIdInput.bind(this));
      // taxIdInput.addEventListener('keypress', this.handleTaxIdKeypress.bind(this));
    }

    // Initialize country/province functionality for billing address
    if (countrySelect && provinceSelect) {
      countrySelect.addEventListener('change', this.handleCountryChange.bind(this, provinceSelect));
      // Trigger initial load
      countrySelect.dispatchEvent(new Event('change'));
    }

    // Initialize country/province functionality for shipping address
    if (shippingCountrySelect && shippingProvinceSelect) {
      shippingCountrySelect.addEventListener('change', this.handleCountryChange.bind(this, shippingProvinceSelect));
      // Trigger initial load
      shippingCountrySelect.dispatchEvent(new Event('change'));
    }

    // Initialize same as billing functionality
    if (sameAsBillingCheckbox && shippingFields) {
      sameAsBillingCheckbox.addEventListener('change', this.handleSameAsBillingChange.bind(this));
      // Trigger initial state
      this.handleSameAsBillingChange({ target: sameAsBillingCheckbox });
    }
  }

  handleCountryChange(provinceSelect, event) {
    const countrySelect = event.target;
    const selectedCountry = countrySelect.value;
    const countryOption = countrySelect.querySelector(`option[value="${selectedCountry}"]`);

    // Clear current options
    provinceSelect.innerHTML = '';

    try {
      // Check if provinces exist
      const provinces = JSON.parse(countryOption.getAttribute('data-provinces'));

      if (provinces.length > 0) {
        // Add placeholder option
        const placeholderOption = document.createElement('option');
        placeholderOption.value = '';
        placeholderOption.textContent = 'Select a state';
        placeholderOption.disabled = true;
        placeholderOption.selected = true;
        provinceSelect.appendChild(placeholderOption);

        // Add province options
        provinces.forEach(province => {
          const option = document.createElement('option');
          option.value = province[0];
          option.textContent = province[1];
          provinceSelect.appendChild(option);
        });
        provinceSelect.disabled = false;
      } else {
        // No provinces
        const option = document.createElement('option');
        option.value = '';
        option.textContent = 'No provinces/states available';
        provinceSelect.appendChild(option);
        provinceSelect.disabled = true;
      }
    } catch (error) {
      console.error('Error parsing provinces data:', error);
      provinceSelect.disabled = true;
    }
  }

  handleSameAsBillingChange(event) {
    const isChecked = event.target.checked;
    const shippingFields = this.querySelector('#shippingAddressFields');
    const billingFields = {
      firstName: this.querySelector('#WholesaleForm_BillingFirstName'),
      lastName: this.querySelector('#WholesaleForm_BillingLastName'),
      companyAttention: this.querySelector('#WholesaleForm_CompanyAttention'),
      address: this.querySelector('#WholesaleForm_Address'),
      apartment: this.querySelector('#WholesaleForm_Apartment'),
      city: this.querySelector('#WholesaleForm_City'),
      province: this.querySelector('#WholesaleForm_AddressProvince'),
      zipCode: this.querySelector('#WholesaleForm_ZipCode'),
      phone: this.querySelector('#WholesaleForm_Phone'),
      country: this.querySelector('#WholesaleForm_AddressCountry')
    };
    const shippingFieldsInputs = {
      firstName: this.querySelector('#WholesaleForm_ShippingFirstName'),
      lastName: this.querySelector('#WholesaleForm_ShippingLastName'),
      companyAttention: this.querySelector('#WholesaleForm_ShippingCompanyAttention'),
      address: this.querySelector('#WholesaleForm_ShippingAddress'),
      apartment: this.querySelector('#WholesaleForm_ShippingApartment'),
      city: this.querySelector('#WholesaleForm_ShippingCity'),
      province: this.querySelector('#WholesaleForm_ShippingProvince'),
      zipCode: this.querySelector('#WholesaleForm_ShippingZipCode'),
      phone: this.querySelector('#WholesaleForm_ShippingPhone'),
      country: this.querySelector('#WholesaleForm_ShippingCountry')
    };

    if (isChecked) {
      // Hide shipping fields
      shippingFields.style.display = 'none';
      
      // Remove required attributes from shipping fields
      Object.values(shippingFieldsInputs).forEach(field => {
        if (field) {
          field.removeAttribute('required');
        }
      });
    } else {
      // Show shipping fields
      shippingFields.style.display = 'block';
      
      // Add required attributes to shipping fields
      Object.values(shippingFieldsInputs).forEach(field => {
        if (field && field !== shippingFieldsInputs.companyAttention) {
          field.setAttribute('required', 'required');
        }
      });

      // Copy billing address to shipping address
      Object.keys(billingFields).forEach(key => {
        const billingField = billingFields[key];
        const shippingField = shippingFieldsInputs[key];
        
        if (billingField && shippingField) {
          if (billingField.tagName === 'SELECT') {
            // For select elements, copy the selected option
            shippingField.value = billingField.value;
            // Trigger change event to update dependent fields (like provinces)
            shippingField.dispatchEvent(new Event('change'));
          } else {
            // For input elements, copy the value
            shippingField.value = billingField.value;
          }
        }
      });
    }
  }

  handleTaxIdInput(event) {
    const input = event.target;
    let value = input.value.replace(/\D/g, ''); // Remove all non-digits
    
    // Format based on length
    if (value.length <= 2) {
      // First two digits
      input.value = value;
    } else if (value.length <= 9) {
      // XX-XXXXXXX format
      input.value = value.slice(0, 2) + '-' + value.slice(2);
    } else if (value.length <= 11) {
      // Check if it should be XXX-XX-XXXX format (first digit > 2 suggests SSN format)
      if (parseInt(value[0]) > 2) {
        input.value = value.slice(0, 3) + '-' + value.slice(3, 5) + '-' + value.slice(5, 9);
      } else {
        // XX-XXXXXXX format
        input.value = value.slice(0, 2) + '-' + value.slice(2, 9);
      }
    } else {
      // Truncate to max length
      if (parseInt(value[0]) > 2) {
        input.value = value.slice(0, 3) + '-' + value.slice(3, 5) + '-' + value.slice(5, 9);
      } else {
        input.value = value.slice(0, 2) + '-' + value.slice(2, 9);
      }
    }
  }

  handleTaxIdKeypress(event) {
    // Only allow digits and backspace
    const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
    const isDigit = /[0-9]/.test(event.key);
    
    if (!isDigit && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }
}

// Register the custom element
customElements.define('wholesale-form', WholesaleForm); 